@switch (inputType) {
  @case ('phone') {
    <ng-container *ngTemplateOutlet="phone" />
  }
  @case ('phone-v2') {
    @if (formControl) {
      <ngx-material-intl-tel-input
        [fieldControl]="formControl"
        [emojiFlags]="false"
        [enableSearch]="true"
        [enablePlaceholder]="true"
        [preferredCountries]="['UA', 'PL', 'US']"
        appearance="outline"
        [disabled]="disabled">
      </ngx-material-intl-tel-input>
    }
  }
  @default {
    <div class="input-container">
      @switch (labelType) {
        @case ('floating') {
          <p-floatlabel [variant]="variant">
            <ng-container *ngTemplateOutlet="default" />
            <label [for]="id">{{ placeholder }}@if (required) {
              <span>*</span>
            }</label>
          </p-floatlabel>
        }
        @default {
          @if (label) {
            <label class="label" [for]="id" [style.color]="labelColor || null">{{ label }}@if (required) {
              <span>*</span>
            }</label>
          }
          <ng-container *ngTemplateOutlet="default" />
        }
      }

      @if (hasError) {
        <p-message severity="error" size="small" variant="simple">
          {{ errorI18nKey | translate: errorI18nParams }}
        </p-message>
      }
    </div>
  }
}

<ng-template #default>
  @switch (inputType) {
    @case ('number') {
      <p-inputnumber
        [fluid]="fluid"
        autocomplete="off"
        [id]="id"
        [invalid]="hasError"
        [size]="size"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [showButtons]="showButtons"
        [buttonLayout]="buttonLayout"
        [locale]="locale"
        [mode]="mode"
        [currency]="currency"
        [currencyDisplay]="currencyDisplay"
        [showClear]="showClear"
        [prefix]="prefix"
        [suffix]="suffix"
        [minFractionDigits]="integerOnly ? 0 : minFractionDigits"
        [maxFractionDigits]="integerOnly ? 0 : undefined"
        [disabled]="disabled"
        [min]="min"
        [max]="max"
        [readonly]="readonly"
        [placeholder]="placeholder"
      ></p-inputnumber>
    }
    @case ('password') {
      <p-password
        [fluid]="fluid"
        autocomplete="off"
        [id]="id"
        [invalid]="hasError"
        [size]="size"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [toggleMask]="toggleMask"
        [feedback]="feedback"
        [showClear]="showClear"
        [minlength]="minlength"
        [maxlength]="maxlength"
        [mediumLabel]="mediumLabel"
        [strongLabel]="strongLabel"
        [weakLabel]="weakLabel"
        [promptLabel]="promptLabel"
        [disabled]="disabled"
      />
    }
    @case ('text-area') {
      <textarea
        pTextarea
        [fluid]="fluid"
        autocomplete="off"
        [id]="id"
        [invalid]="hasError"
        [pSize]="size"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [rows]="rows"
        [autoResize]="autoResize"
        [disabled]="disabled"
        [readonly]="readonly"
      ></textarea>
    }
    @case ('mask') {
      <p-inputmask
        [fluid]="fluid"
        autocomplete="off"
        [id]="id"
        [invalid]="hasError"
        [size]="size"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [autoClear]="autoClear"
        [showClear]="showClear"
        [mask]="mask"
        [pattern]="pattern"
        [slotChar]="slotChar"
        [unmask]="unmask"
        [disabled]="disabled"
        [readonly]="readonly"
      />
    }
    @case ('auto-complete') {
      <p-autocomplete
        [size]="size"
        [invalid]="hasError"
        [suggestions]="suggestions"
        [searchMessage]="searchMessage"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [minlength]="minlength"
        [maxlength]="maxlength"
        [disabled]="disabled"
        [virtualScrollOptions]="virtualScrollOptions"
        [virtualScroll]="virtualScroll"
        [lazy]="lazy"
        [completeOnFocus]="completeOnFocus"
        [showClear]="showClear"
        [multiple]="multiple"
        [emptyMessage]="emptyMessage"
        [delay]="delay"
        [(ngModel)]="input"
        [readonly]="readonly"
        (ngModelChange)="onchange($event)"
      ></p-autocomplete>
    }
    @case ('otp') {
      <p-inputotp
        [size]="size"
        [invalid]="hasError"
        [disabled]="disabled"
        [length]="length"
        [integerOnly]="integerOnly"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [readonly]="readonly"
      ></p-inputotp>
    }
    @case ('editor') {
      <p-editor
        [invalid]="hasError"
        [style]="{ height: '320px' }"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        (blur)="onBlur(); handleTouched()"
        (focusout)="onBlur(); handleTouched()"
        [readonly]="readonly"
        [disabled]="disabled"
        [placeholder]="placeholder"
      >
        <ng-template #header>
            <span class="ql-formats">
              <button type="button" class="ql-bold" aria-label="Bold"></button>
              <button type="button" class="ql-italic" aria-label="Italic"></button>
              <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
              <button type="button" class="ql-clean" aria-label="Remove Styles"></button>
             </span>
        </ng-template>
      </p-editor>
    }
    @default {
      <input
        pInputText
        [type]="inputType === 'date' ? 'date' : 'text'"
        [fluid]="fluid"
        autocomplete="off"
        [id]="id"
        [invalid]="hasError"
        [pSize]="size"
        [(ngModel)]="input"
        (ngModelChange)="onchange($event)"
        [pKeyFilter]="pKeyFilter"
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        (blur)="onBlur(); handleTouched()"
        (focusout)="onBlur(); handleTouched()"
      />
    }
  }
</ng-template>


<ng-template #phone>
  <div class="phone-container">
    <div class="phone-input">
      <p-floatlabel [variant]="variant">
        <p-select
          [fluid]="fluid"
          [options]="options"
          [optionLabel]="optionLabel"
          [optionValue]="optionValue"
          [filter]="true"
          (onChange)="selectPhone($event)"
          [invalid]="invalid && !mask"
          [disabled]="disabled"
          [showClear]="showClear"
        >
          <ng-template let-phone #item>
            <div class="d-flex align-items-center justify-content-between gap-2 w-100">
              <div>
                <img
                  [src]="phone.link"
                  style="width: 18px; border: 1px #ccc solid; border-radius: 2px"
                />
                {{ phone.code }}
              </div>
              <div>{{ phone.title }}</div>
            </div>
          </ng-template>
        </p-select>
        <label [for]="id">{{ 'choose_a_country' | translate }}@if (required) {
          <span>*</span>
        }</label>
      </p-floatlabel>
      @if (invalid && !mask) {
        <p-message severity="error" size="small" variant="simple">{{ 'field_cannot_be_empty' | translate }}
        </p-message>
      }
    </div>
    <div class="phone-input">
      <p-floatlabel [variant]="variant">
        @if (!mask) {
          <input
            pInputText
            [fluid]="fluid"
            autocomplete="off"
            [id]="id"
            [invalid]="invalid"
            [pSize]="size"
            [ngModel]="input"
            [disabled]="disabled"
            [readonly]="true"
          />
        } @else {
          <p-inputmask
            #im
            [fluid]="fluid"
            [id]="id"
            [invalid]="invalid"
            [size]="size"
            (onInput)="onInputMask($event)"
            (onBlur)="onInputMask($event)"
            [autoClear]="autoClear"
            [showClear]="showClear"
            [mask]="mask"
            [slotChar]="slotChar"
            [unmask]="unmask"
            [disabled]="!mask"
            [ngModel]="input"
            [readonly]="readonly"
          />
        }
        <label [for]="id">{{ 'enter_phone_number' | translate }}@if (required) {
          <span>*</span>
        }</label>
      </p-floatlabel>
      @if (invalid) {
        <p-message severity="error" size="small" variant="simple">
          @if (!phoneMaskTempValue) {
            {{ 'field_cannot_be_empty' | translate }}
          }

          @if (phoneMaskTempValue && phoneMaskTempValue.length < 12) {
            {{ 'the_number_is_incorrect' | translate }}
          }
        </p-message>
      }
    </div>
  </div>
</ng-template>
